import React, { useMemo } from 'react';
import { buildStudioGenerateCostLabel, creditCostForNav } from '@/constants/ipeCredits';
import useModuleCreditsRevision from '@/hooks/useModuleCreditsRevision';

export function useStudioGenerateCost(navId, { imageCount = 0, total, unit, resolution } = {}) {
  const moduleCreditsRevision = useModuleCreditsRevision();
  return useMemo(() => {
    void moduleCreditsRevision;
    const label = buildStudioGenerateCostLabel(navId, { imageCount, total, unit, resolution });
    return {
      label,
      hasCost: Boolean(label),
    };
  }, [navId, imageCount, total, unit, resolution, moduleCreditsRevision]);
}

/** 订阅定价刷新，供生成按钮 has-cost 样式（避免仅子组件更新而父级 class 不刷新） */
export function useStudioGenerateBtnHasCost(navId, options = {}) {
  return useStudioGenerateCost(navId, options).hasCost;
}

export default function StudioGenerateCostLabel({
  navId,
  imageCount = 0,
  total,
  unit,
  resolution,
  className = 'img2img-studio__generate-cost',
}) {
  const { label } = useStudioGenerateCost(navId, { imageCount, total, unit, resolution });
  if (!label) return null;
  return <span className={className}>{label}</span>;
}

/** @deprecated 组件内请用 useStudioGenerateBtnHasCost，否则定价异步注入后按钮样式可能不更新 */
export function studioGenerateBtnHasCost(navId, options = {}) {
  return Boolean(creditCostForNav(navId, options));
}
